module.exports = __webpack_public_path__ + "img/students_nodata.5ac2d84d.png";